/**
 * When siteVizPdfImport is on, PDF files are added to a drafting space one
 * page at a time and use a different context menu action and dialog.
 */
export function isPdfModelFile(fileName: string): boolean {
  return /\.pdf$/i.test(fileName);
}
